import { Segment } from '@mi-front/core';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import debugFn from 'debug';
import { apiClient } from '../../../api';

const debug = debugFn('segments-api');

/**
 * React Query wrapper around api.segments.fetchRange()
 * TODO: use generated client or hook when implementing a library
 * like Kubb.
 */
export function useApiSegmentsRange(
  stationId: string,
  from: string | number,
  to: string | number,
  options?: Partial<UseQueryOptions<Segment[]>>,
) {
  // if the range is in the future, do not cache data more than 30 seconds
  // otherwise cache for 1 hour
  const staleTime = new Date(to) >= new Date() ? 30 * 1000 : 60 * 60 * 1000;

  return useQuery({
    queryKey: [
      'segments-range',
      {
        stationId,
        from,
        to,
      },
    ],

    queryFn: () => {
      return apiClient.segments
        .fetchRange(stationId, from, to)
        .then((res) => res as Segment[])
        .then((res) => {
          debug(
            'Fetched %d segments from %s to %s',
            res.length,
            res[0]?.startTs ? new Date(res[0].startTs).toLocaleTimeString() : 'N/A',
            res[res.length - 1]?.endTs
              ? new Date(res[res.length - 1].endTs).toLocaleTimeString()
              : 'N/A',
          );
          return res;
        });
    },

    staleTime,
    placeholderData: () => undefined,
    ...options,
  });
}
